module.exports = __webpack_public_path__ + "static/media/headset.1bf96198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/contacto/headset.svg
// module id = 182
// module chunks = 0